import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { close } from 'ionicons/icons'
import { useEffect } from 'react'
import { Html5Qrcode, Html5QrcodeSupportedFormats, Html5QrcodeScanType } from 'html5-qrcode'

interface Props {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
}

const BarCodeScanner = ({ onDismiss }: Props) => {
  const config = {
    fps: 2,
    aspectRatio: 1.777778,
    qrbox: { width: 300, height: 100 },
    rememberLastUsedCamera: true,
    supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
  }
  let scanner: any = null

  useEffect(() => {
    const html5QrCode = new Html5Qrcode('reader', {
      verbose: false,
      formatsToSupport: [Html5QrcodeSupportedFormats.CODE_128]
    })

    html5QrCode.start({ facingMode: 'environment' }, config, onScanSuccess, onScanFailed)

    scanner = html5QrCode
  }, [Html5Qrcode])

  const onScanSuccess = (decodedText: any, decodedResult: any) => {
    stopScanning()
    onDismiss(decodedText, 'confirm')
  }
  const onScanFailed = (error: any) => {
    console.log('error ->', error)
  }

  const stopScanning = () => {
    scanner
      .stop()
      .then(() => {
        // QR Code scanning is stopped.
      })
      .catch((err: any) => {
        console.log(err)
      })
  }

  const onBack = () => {
    onDismiss(null, 'cancel')
    stopScanning()
  }

  return (
    <IonPage>
      <IonHeader id="camera-header">
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={onBack}>
              <IonIcon icon={close} />
            </IonButton>
          </IonButtons>
          <IonTitle className="headers-left-padding">Escanear código</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div id="reader"></div>
      </IonContent>
    </IonPage>
  )
}

export default BarCodeScanner
